import { P } from 'ia-react-core';
import { redirectTo, Section } from 'omni-package-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Constants from '../../../../Constants';
import { Account } from '../../../../interfaces/Account';
import { StyledButton } from '../LoginInformation.styles';

export interface UsernameProps {
  account: Account;
}

const Username: FC<UsernameProps> = ({ account }) => {
  const { t } = useTranslation('Account');
  const navigate = useNavigate();

  return (
    <section data-testid="username-1">
      <Section data-testid="username-title" name={t('username')}>
        <P data-testid="username-value">{account.username}</P>
      </Section>
      {!account.isUsernameReadOnly &&
        <StyledButton data-testid="username-button" outline onClick={() => redirectTo(Constants.UsernameFormPath, navigate)}>{t('buttonModify')}</StyledButton>}
    </section>
  );
};

export default Username;
